import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconCanny: React.FC = () => (
    <Icon viewBox="0 0 12 16" fill="none">
        <path
            d="M5.63009 16C2.53542 16 0 13.4871 0 10.4V5.6C0 2.51285 2.53542 0 5.63009 0C8.37868 0 10.716 1.96364 11.1699 4.66708C11.2426 5.10345 10.9542 5.51473 10.5179 5.58997C10.0815 5.6627 9.67273 5.36928 9.59749 4.93292C9.27147 3.00188 7.62633 1.6 5.66019 1.6C3.44828 1.6 1.6652 3.39561 1.6652 5.6V10.4C1.6652 12.6069 3.44828 14.4 5.66019 14.4C7.62382 14.4 9.27649 12.9981 9.6 11.0671C9.67273 10.6307 10.084 10.3373 10.5179 10.41C10.9542 10.4828 11.2351 10.8966 11.1624 11.3304C10.7135 14.0364 8.37618 16 5.63009 16Z"
            fill="currentColor"
        />
        <g opacity="0.5">
            <path
                d="M3.85194 8.71978C3.41056 8.71978 3.08203 8.36116 3.08203 7.91978V5.60504C3.08203 4.18059 4.23062 3.02197 5.66009 3.02197C6.63564 3.02197 7.51338 3.56367 7.95977 4.43639C8.1604 4.83012 8.00241 5.31163 7.60868 5.51225C7.21495 5.71288 6.73093 5.5574 6.53031 5.16367C6.35977 4.82762 6.00366 4.61946 5.6325 4.61946C5.08579 4.61946 4.62435 5.06084 4.62435 5.60254V7.91727C4.62184 8.36116 4.29332 8.71978 3.85194 8.71978Z"
                fill="currentColor"
            />
        </g>
    </Icon>
);
